module.exports = __webpack_public_path__ + "static/kwickshop-min-a3ec7342fc14b473bacf292ba1f190f5.png";